(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('NormaDetailController', NormaDetailController);

    NormaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Norma', 'IntrumentoRelacionado', 'Documento', 'OrganoRelevante', 'PalabraClave', 'TipoOrdenamiento', 'Materia'];

    function NormaDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Norma, IntrumentoRelacionado, Documento, OrganoRelevante, PalabraClave, TipoOrdenamiento, Materia) {
        var vm = this;

        vm.norma = entity;
        vm.previousState = previousState.name;
        vm.previousStateParams = previousState.params;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('sgnmrApp:normaUpdate', function(event, result) {
            vm.norma = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
